import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHeating = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19 11H3V21H21V11H19ZM7 15V19H5V13H7V15ZM11 19H9V17V15V13H11V19ZM15 19H13V17V15V13H15V19ZM19 19H17V17V15V13H19V19Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 7.14002C10.5272 7.59513 10.6467 8.03995 10.8513 8.44739C11.0559 8.85484 11.3412 9.21638 11.69 9.51002L13.11 8.09002C12.9476 7.97157 12.8102 7.82229 12.7055 7.65071C12.6008 7.47913 12.531 7.2886 12.5 7.09002C12.5453 6.83433 12.6594 6.59579 12.83 6.40002C13.2349 5.88034 13.4689 5.24806 13.5 4.59002C13.4742 4.13319 13.3553 3.68646 13.1506 3.2772C12.946 2.86795 12.66 2.5048 12.31 2.21002L10.89 3.69002C11.207 3.91735 11.4252 4.25717 11.5 4.64002C11.4538 4.90335 11.3362 5.14895 11.16 5.35002C10.7603 5.86412 10.5297 6.48948 10.5 7.14002V7.14002Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 7.14001C5.52602 7.59537 5.64503 8.04057 5.8497 8.44818C6.05436 8.85578 6.34034 9.21715 6.69 9.51001L8.11 8.09001C7.78449 7.84857 7.56572 7.48993 7.5 7.09001C7.54531 6.83431 7.65939 6.59578 7.83 6.40001C8.22536 5.89414 8.45887 5.28073 8.5 4.64001C8.47415 4.18318 8.35527 3.73644 8.15064 3.32719C7.94601 2.91793 7.65995 2.55479 7.31 2.26001L5.89 3.68001C6.21395 3.92287 6.4323 4.28083 6.5 4.68001C6.45381 4.94334 6.3362 5.18894 6.16 5.39001C5.7679 5.89307 5.53775 6.50331 5.5 7.14001V7.14001Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 7.14002C15.5272 7.59513 15.6467 8.03995 15.8513 8.44739C16.0559 8.85484 16.3412 9.21638 16.69 9.51002L18.11 8.09002C17.9476 7.97157 17.8102 7.82229 17.7055 7.65071C17.6008 7.47913 17.531 7.2886 17.5 7.09002C17.5453 6.83433 17.6594 6.59579 17.83 6.40002C18.2349 5.88034 18.4689 5.24806 18.5 4.59002C18.4742 4.13319 18.3553 3.68646 18.1506 3.2772C17.946 2.86795 17.66 2.5048 17.31 2.21002L15.89 3.69002C16.207 3.91735 16.4252 4.25717 16.5 4.64002C16.4538 4.90335 16.3362 5.14895 16.16 5.35002C15.7603 5.86412 15.5297 6.48948 15.5 7.14002V7.14002Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconHeating;
